<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  all({ page, limit, q }) {
    return axios.get(`enviromental_study_types?page=${ page }&limit=${ limit }&q=${ q }`, AS.getDefaultHeaders());
  },
  createOrUpdate(payload) {
    if (payload.id === null) {
      return axios.post('enviromental_study_types', {enviromental_study_type: payload}, AS.getDefaultHeaders());
    }
    return axios.patch(`enviromental_study_types/${ payload.id }`, payload, AS.getDefaultHeaders());
  },
  destroy(id){
    return axios.delete(`enviromental_study_types/${id}`)
  },

  fetchEnviromentalStudyTypes() {
    return axios.get('enviromental_study_types', AS.getDefaultHeaders());
  },
};
</script>
